function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHideRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.203 20.203a4 4 0 01-4-4c0-.74.215-1.425.565-2.02l5.455 5.454a3.96 3.96 0 01-2.02.566zm0-8a4 4 0 014 4 3.96 3.96 0 01-.566 2.02l-5.454-5.455a3.966 3.966 0 012.02-.565zm14.203 16.789l-5.703-5.703c3.842-2.952 5.5-7.086 5.5-7.086s-4-10-14-10c-2.689 0-4.941.727-6.801 1.784L3.414 2 2 3.414l5.703 5.703c-3.842 2.952-5.5 7.086-5.5 7.086s4 10 14 10c2.689 0 4.941-.727 6.802-1.784l5.987 5.987 1.414-1.414z",
    fill: props.color
  }));
}

export default SvgIconHideRexFilled;